function getAllGridItems() {
    return document.querySelectorAll('.grid-item');
}

function addEventListenersToGridItems() {
    const gridItems = document.querySelectorAll('.grid-item');
    gridItems.forEach(gridItem => {
        gridItem.addEventListener('click', handleGridItemClick);
    });
}

function clearClickedElements () {
    clickedItems = [];

}


handleGridItemClick = (event) => {
    target = event.target
    elementClickedAnimation (target);

    allGridItems = getAllGridItems();
    targetIndex = Array.from(allGridItems).indexOf(target);
    clickedItems.push(targetIndex);
    console.log({clickedItems})
}


addEventListenersToGridItems();

async function awaitUserInput(numberOfGridItemsToShow) {
    while (clickedItems.length < numberOfGridItemsToShow) {
        await new Promise(r => setTimeout(r, 100));
    }
    console.log("user clicked expected number of items");
}